module.exports = __webpack_public_path__ + "img/logo-dark.3436b2fd.png";